export default __webpack_public_path__ + "./assets/img/static-group-creation.gif";